// (c) Copyright 2024-2025 Hewlett Packard Enterprise Development LP

import {
  add,
  flush,
  init,
  setTransport,
  track,
} from "@amplitude/analytics-browser"
import { MemoryStorage } from "@amplitude/analytics-core"
import { Events } from "./constants"
import { PageHide, UrlChange } from "./instrumentations"
import { locationPlugin, staticValuesPlugin } from "./plugins"
import { env } from "../utils/env"

const config = {
  defaultTracking: false,
  fetchRemoteConfig: false,
  trackingOptions: { ipAddress: false },

  disableCookies: true,
  cookieStorageProvider: new MemoryStorage(),
  identityStorage: "none",
}

const defaultInstrumentations = [
  new UrlChange((e) => {
    track(Events.SCREEN_VIEWED, { url: e.detail.href })
  }),
  new PageHide(() => {
    setTransport("beacon")
    flush()
  }),
]

/**
 * Initialize analytics and telemetry.
 */
export function initialize(instrumentations = defaultInstrumentations) {
  // if no key just return without init
  if (!env.REACT_APP_AMPLITUDE_PROJECT_KEY) {
    return
  }

  // init amplitude, userId added later after authentication
  add(staticValuesPlugin())
  add(locationPlugin())
  init(env.REACT_APP_AMPLITUDE_PROJECT_KEY, "", config)

  instrumentations.forEach((i) => i.start())
}
